






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Link extends Vue {
  @Prop() private title!: string;

  @Prop() private target!: string;

  @Prop() private href!: boolean;

  private get text(): string | null {
    if (this.title) {
      return this.title;
    } else if (
      this.$slots &&
      this.$slots.default &&
      this.$slots.default.length
    ) {
      return (this.$slots.default[0] as { text: string }).text;
    }
    return null;
  }
}
